<script setup lang="ts">
import Wrapper                                  from "../../Layouts/Wrapper.vue";
import Section                                  from "../../CommonComponents/Section.vue";
import Container                                from "../../CommonComponents/Container.vue";
import __                                       from "../../../Utils/tranlation";
import SectionTitle                             from "../../CommonComponents/SectionTitle.vue";
import { Accordion }                            from "flowbite";
import type { AccordionOptions, AccordionItem } from "flowbite";
import { findElem }                             from "../../../Utils/helpers";
import { onMounted, onUpdated }                 from "vue";
import Pagination                               from "../../CommonComponents/Pagination.vue";
import AlertDanger                              from "../../CommonComponents/AlertDanger.vue";
import Search                                   from "./Components/Search.vue";
import type { TypePaginationData }              from "../../../Utils/CommonTypes/qr_code";
import HistoryList                              from "../../CommonComponents/HistoryList.vue";

type TypeProps = TypePaginationData & {
    title : string,
    errors? : {
        [key : string] : string
    }
};

const props = defineProps<TypeProps>();

const accordion = () : void => {
    const accordionEl = <HTMLElement | null>findElem('#accordion-collapse'),
        accordionItems : AccordionItem[] = [],
        histories_data = props.pagination_data.data;

    histories_data.forEach(history_data => {
        const item : AccordionItem = {
            id: `accordion-collapse-heading-${history_data.id}`,
            triggerEl: <HTMLElement>findElem(`#accordion-collapse-heading-${history_data.id}`),
            targetEl: <HTMLElement>findElem(`#accordion-collapse-body-${history_data.id}`),
            active: false,
        };

        accordionItems.push(item);
    });

    const options : AccordionOptions = {
        alwaysOpen: false,
        activeClasses: 'bg-gray-300 dark:bg-blue-600 dark:text-white ',
        inactiveClasses: 'text-gray-100 dark:text-gray-100 ',
    };

    const accordion = new Accordion(accordionEl, accordionItems, options);

    accordion.init();
};

onMounted(() => {
    accordion();
});

onUpdated(() => {
    accordion();
});
</script>

<template>
    <Wrapper :title>
        <template #main>
            <Section>
                <Container>
                    <SectionTitle class="mb-6">
                        {{ __('text_title') }}
                    </SectionTitle>

                    <template v-if="errors">
                        <AlertDanger v-for="error_message in errors" :error="error_message"></AlertDanger>
                    </template>

                    <Search></Search>

                    <HistoryList :pagination_data></HistoryList>

                    <Pagination :pagination_data></Pagination>
                </Container>
            </Section>
        </template>
    </Wrapper>
</template>

<style scoped>

</style>
